import { marker as _ } from '@jsverse/transloco-keys-manager/marker';

const __translocoMessages__ = [
  _('animal.whereabout.SOCIAL_MEDIA'),
  _('animal.whereabout.NEWSPAPER'),
  _('animal.whereabout.WEBSITE'),
  _('animal.whereabout.FRIENDS_AND_ACQUAINTANCES'),
  _('animal.whereabout.RECOMMENDATION'),
  _('animal.whereabout.FROM_THE_AREA'),

  _('animalContact.types.authorized_pickup'),
  _('animalContact.types.finder'),
  _('animalContact.types.giver'),
  _('animalContact.types.owner'),
  _('animalContact.types.supervisor'),
  _('animalContact.types.son_daughter'),
  _('animalContact.types.partner'),
  _('animalContact.types.parent'),
  _('animalContact.types.brother_sister'),
  _('animalContact.types.person_taking_over'),
  _('animalContact.types.neighbor'),
];